import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/other'
    },
    {
      path: '/extract',
      name: 'extract',
      component: resolve=>(require(["@/components/extract/extract"],resolve)),
       meta:{
        name: '三栏页面(关键字文件单页)'
      }
    },
    {
    	path: '/extract_file',
    	name: 'extract_file',
    	component: resolve=>(require(["@/components/extract_file/extract_file"],resolve)),
       meta:{
        name: '三栏页面(关键字文件)'
      }
    },
    {
      path: '/extract_folder',
      name: 'extract_folder',
      component: resolve=>(require(["@/components/extract_folder/extract_folder"],resolve)),
      meta:{
        name: '三栏页面(关键字文件夹)'
      }
    },
    {
      path: '/uploadFolder',
      name: 'uploadFolder',
      component:  resolve => (require(["@/components/common/uploadFolder/uploadFolder"],resolve)),
      meta:{
        name: '上传'
      }
    },
    {
      path: '/viewOCR',
      name: 'viewOCR',
      component: resolve => (require(["@/components/viewOCR/viewOCR"],resolve)),
      meta:{
        name: 'OCR列表'
      }
    },
    {
      path: '/other',
      name: 'other',
      component:  resolve => (require(["@/components/other/other"],resolve)),
      meta:{
        name: '辅助入口'
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js